<template>
  <div class="ticket-head-container">
<!--    <el-form :inline="true">
      <el-form-item>
        <el-button type="primary" @click="fetchData">查询</el-button>
      </el-form-item>
    </el-form>-->

    <el-table :data="displayData" border>
      <el-table-column prop="_checked" label="选择" width="80">
        <template #default="{row}">
          <el-checkbox v-model="row._checked" @change="(val) => handleCheckChange(row, val)" />
        </template>
      </el-table-column>
      <el-table-column prop="label" label="字段名称" />
    </el-table>
  </div>
</template>

<script>
import requestTicket from '@/utils/requestTicket'

export default {
  name: 'TicketHead',
  props: {
    typeId: {
      type: Number
    },
    typeName: {
      type: String
    }
  },
  data() {
    return {
      tableData: [], // 所有查询数据
      displayData: [
        { label: '名称', prop: 'name' },
        // { label: '物料id', prop: 'materialId' },
        // { label: '物料编号', prop: 'materialCode' },
        { label: '物料名称', prop: 'materialName' },
        { label: '数量', prop: 'number' },
        { label: '单价', prop: 'price' },
        { label: '金额', prop: 'money' },
        { label: '折扣', prop: 'discount' },
        { label: '折后单价', prop: 'discountPrice' },
        { label: '备注', prop: 'comment' },
        { label: '费用项目编号', prop: 'costitemCode' },
        { label: '费用项目名称', prop: 'costitemName' },
        { label: '收入科目编号', prop: 'incomeSubjectCode' },
        { label: '收入科目名称', prop: 'incomeSubjectName' },
        { label: '科目编号', prop: 'subjectId' },
        { label: '总账科目', prop: 'ledgerId' },
        { label: '明细科目', prop: 'detailId' },
        { label: '借方', prop: 'debit' },
        { label: '贷方', prop: 'creditor' }
      ], // 所有字段
    }
  },
  mounted() {
    this.fetchData()
  },
  methods: {
    async fetchData() {
      try {
        const res = await requestTicket.post('/Ticketing/ticket-line-head/findAll')
        this.tableData = res.data.map(item => ({
          ...item,
          _checked: false
        }))
        this.filterData()
      } catch (error) {
        console.error('获取数据失败:', error)
      }
    },

    filterData() {
      if (!this.typeId) {
        return
      }
      
      // 根据typeId筛选逻辑（示例筛选逻辑，需根据实际需求调整）
      this.displayData = this.displayData.map(item => {
        const _checked = this.tableData.find(t => {
        return (t.typeId === this.typeId &&
            t.label === item.label &&
            t.prop === item.prop) // 根据label和prop匹配设置选中状态
        })
        if (_checked) {
          return {
            ..._checked,
            _checked: true
          }
        } else {
          return {
            ...item,
            _checked: false
          }
        }
      })
    },

    async handleCheckChange(row, checked) {
      try {
        if (checked) {
          row.typeId = this.typeId
          row.typeName = this.typeName
          await requestTicket.post('/Ticketing/ticket-line-head/save', row)
        } else {
          await requestTicket.delete(`/Ticketing/ticket-line-head/${row.id}`)
        }
        await this.fetchData() // 操作后刷新数据
      } catch (error) {
        console.error('操作失败:', error)
        row._checked = !checked // 回滚选中状态
      }
    }
  }
}
</script>

<style scoped>
.ticket-head-container {
  padding: 20px;
}
.el-table {
  margin-top: 20px;
}
</style>